import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow2Up = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 13.84 23.94'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M13.538,7.685 C13.345,7.879 13.092,7.976 12.839,7.976 C12.586,7.976 12.333,7.879 12.140,7.684 L7.899,3.404 L7.899,22.928 C7.899,23.478 7.457,23.925 6.911,23.925 C6.366,23.925 6.060,23.491 6.060,22.940 L6.060,3.267 L1.682,7.684 C1.296,8.073 0.671,8.073 0.285,7.685 C-0.101,7.295 -0.101,6.664 0.285,6.275 L6.213,0.292 C6.293,0.211 6.392,0.155 6.493,0.109 C6.612,0.045 6.747,0.000 6.911,0.000 C7.184,0.000 7.431,0.112 7.609,0.292 C7.610,0.292 7.610,0.292 7.610,0.292 L13.538,6.275 C13.923,6.664 13.923,7.295 13.538,7.685 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow2Up.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
